(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kk-shop-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-shop-menu')) {
    customElements.define('kk-shop-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const updateHeight = () => {
          const submenu = this.closest('.menu-list__submenu');
          const header = this.closest('header-menu')?.closest('header-component');
          if (!submenu || !header || submenu.inert) return;
          const height = submenu.offsetHeight;
          header.style.setProperty('--submenu-height', height + 'px');
          header.style.setProperty('--full-open-header-height', (height + header.offsetHeight) + 'px');
        };
        this.querySelectorAll('details').forEach(details => {
          details.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') details.open = true;
          });
          details.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse' && !details.contains(document.activeElement)) details.open = false;
          });
          details.addEventListener('toggle', () => requestAnimationFrame(updateHeight));
          details.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              details.open = false;
              details.querySelector('summary').focus();
              event.stopPropagation();
            }
          });
        });
        this.observer = new ResizeObserver(updateHeight);
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
